// ── API utility ────────────────────────────────────────────────────────────
const BASE = process.env.REACT_APP_API_URL || '';

export async function api(path, options = {}) {
  const token = sessionStorage.getItem('awwt_imp_token') || localStorage.getItem('awwt_token');
  const res = await fetch(`${BASE}/api${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {})
    },
    body: options.body ? JSON.stringify(options.body) : undefined
  });

  if (res.status === 401) {
    localStorage.removeItem('awwt_token');
    window.location.href = '/login';
    return;
  }

  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`);
  return data;
}

export const apiGet    = (path)           => api(path);
export const apiPost   = (path, body)     => api(path, { method: 'POST',   body });
export const apiPut    = (path, body)     => api(path, { method: 'PUT',    body });
export const apiDelete = (path)           => api(path, { method: 'DELETE' });

export function fmtDate(d) {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
}

export function daysUntil(d) {
  if (!d) return null;
  return Math.ceil((new Date(d) - new Date()) / 86400000);
}

export function statusLabel(s) {
  return {
    draft: 'Draft', submitted: 'Submitted', under_review: 'Under Review',
    revisions_requested: 'Revisions Needed', approved: 'Approved',
    rejected: 'Rejected', expired: 'Expired'
  }[s] || s;
}
